module.exports = __webpack_public_path__ + "static/media/RTS.27d80117.png";